<template>
  <DataAdapterToolsPanel v-if="adapter" :adapter="adapter" />
</template>

<script>
import DataAdapterToolsPanel from '@/components/data-adapters/DataAdapterTools.vue';

export default {
  name: 'ProjectDataAdapterTools',
  components: { DataAdapterToolsPanel },
  props: {
    adapter: Object,
  },
};
</script>
